import { defineMessages } from "shared/helpers/i18n/defineMessages";

const messages = defineMessages({
  aboutYou: {
    id: "loyalty.signup.about-you-title",
    defaultMessage: "About You",
  },
  firstNameField: {
    id: "loyalty.signup.field.first-name-label",
    defaultMessage: "First name",
  },
  lastNameField: {
    id: "loyalty.signup.field.last-name-label",
    defaultMessage: "Last name",
  },
  genderField: {
    id: "loyalty.signup.field.gender-label",
    defaultMessage: "Gender (Optional)",
  },
  dateOfBirthField: {
    id: "loyalty.signup.field.date-of-birth-label",
    defaultMessage: "Date of birth",
  },
  contactDetails: {
    id: "loyalty.signup.contact-details-title",
    defaultMessage: "Contact Details",
  },
  emailField: {
    id: "loyalty.signup.field.email-label",
    defaultMessage: "Email",
  },
  phoneNumberField: {
    id: "loyalty.signup.field.phone-number-label",
    defaultMessage: "Phone no.",
  },
  termsAndConditionsField: {
    id: "loyalty.signup.field.terms-and-conditions-label",
    defaultMessage: "I agree to the Terms & Conditions of the Rewards program.",
  },
  sendNewsletterField: {
    id: "loyalty.signup.field.send-newsletter-label",
    defaultMessage: "I agree to receive marketing emails.",
  },
  save: {
    id: "loyalty.signup.save-update-label",
    defaultMessage: "Save & Update",
  },
  genericError: {
    id: "loyalty.edit.generic-error-message",
    defaultMessage: "An error has occured, check your info and retry",
  },
  genericSuccess: {
    id: "loyalty.edit.generic-success-message",
    defaultMessage: "Your info has been updated",
  },
});

export const errorMessages = defineMessages({
  required: {
    id: "loyalty.signup.error.field-required-label",
    defaultMessage: "This field is required",
  },
  email: {
    id: "loyalty.signup.error.invalid-email-label",
    defaultMessage: "This field must be a valid email",
  },
});

export default messages;
